import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { formatFechaDeNacimiento } from "../utils/utils";
import DataValue from "../utils/DataValue";

export default function UserInfo({ userdata }) {
	const {
		nombre,
		documento,
		sexo,
		nacimiento,
		edad,
		legajo,
		estado_observacion,
	} = userdata;
	return (
		<Flex
			px={2}
			py={5}
			borderRadius={5}
			position={"relative"}
			flexDir={"column"}
			border="1px solid #333"
			w={["100%", "400px"]}
			gap={4}
		>
			<Text
				bg={"#f9fad2"}
				position={"absolute"}
				top={0}
				left={0}
				transform={"translateY(-50%)"}
				px={2}
				fontWeight={600}
			>
				Datos del Socio
			</Text>
			<DataValue data={"Nombre"} value={nombre} />
			<Flex gap={4}>
				<Flex w={["52%", "50%"]}>
					<DataValue data={"Documento"} value={documento} />
				</Flex>
				<DataValue data={"Legajo"} value={legajo} />
			</Flex>
			<Flex gap={4}>
				<Flex w={["52%", "50%"]}>
					<DataValue
						data={"F. Nacimiento"}
						value={formatFechaDeNacimiento(nacimiento)}
					/>
				</Flex>

				<DataValue data={"Edad"} value={edad} />
				<DataValue data={"Sexo"} value={sexo === "MASCULINO" ? "M" : "F"} />
			</Flex>
			{estado_observacion && (
				<Text fontWeight={600} color="red" textAlign={"center"}>
					{estado_observacion}
				</Text>
			)}
		</Flex>
	);
}
